import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";
import Registration from "./pages/Registration";
import Home from "./pages/Home";
import MainPage from "./pages/MainPage";
import Profile from "./components/Profile";
import ForgotPassword from "./components/ForgotPassword";
import { useEffect, useState } from "react";
import { auth } from "./components/Firebase";
import About from "./pages/About";
import ContactUs from "./pages/ContactUs";
import Spinner from './components/Spinner';
import Liked from "./components/Liked";
import Cart from "./pages/Cart";
import ProductPage from "./components/ProductPage";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // ✅ Add loading state

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser);
      setLoading(false); // ✅ Stop loading once Firebase confirms authentication
    });

    return unsubscribe;
  }, []);

  if (loading) {
    return <Spinner/>; // ✅ Show a loading message or a spinner
  }

  const router = createBrowserRouter([
    {
      path: '/',
      element: user ? <Navigate to="/mainpage" /> : <Home />,
    },
    {
      path: '/register',
      element: <Registration />,
    },
    {
      path: '/mainpage',
      element: <MainPage />,
    },
    {
      path: '/profile',
      element: <Profile />,
    },
    {
      path: '/forgotpassword',
      element: <ForgotPassword />,
    },
    {
      path: '/about',
      element: <About />,
    },
    {
      path: '/contact',
      element: <ContactUs />,
    },
    {
      path : '/liked',
      element : <Liked/>,
    },
    {
      path : "/cart",
      element : <Cart/>
    },
    {
      path : "/product/:id",
      element : <ProductPage/>
    }
  ]);

  return <RouterProvider router={router} />;
}

export default App;
